var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadsetMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5787",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1 46V43H39V40.3H31.6V25.5H39V22.1C39 17.9666 37.55 14.4083 34.65 11.425C31.75 8.44162 28.2333 6.94995 24.1 6.94995C19.9667 6.94995 16.4167 8.44162 13.45 11.425C10.4833 14.4083 9 17.9666 9 22.1V25.5H16.4V40.3H9C8.2 40.3 7.5 40 6.9 39.4C6.3 38.8 6 38.1 6 37.3V22.1C6 19.6089 6.475 17.2608 7.425 15.0559C8.375 12.8509 9.66667 10.9237 11.3 9.2742C12.9333 7.6247 14.8534 6.32495 17.0602 5.37495C19.267 4.42495 21.617 3.94995 24.1102 3.94995C26.6034 3.94995 28.9417 4.42495 31.125 5.37495C33.3083 6.32495 35.2009 7.6247 36.8026 9.2742C38.4043 10.9237 39.671 12.8509 40.6026 15.0559C41.5342 17.2608 42 19.6089 42 22.1V43C42 43.7999 41.7 44.5 41.1 45.1C40.5 45.7 39.8 46 39 46H24.1ZM9 37.3H13.4V28.5H9V37.3ZM34.6 37.3H39V28.5H34.6V37.3Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetMic);
export default __webpack_public_path__ + "static/media/headset_mic.7b19d486eb389bbe9d4c93212e74ba66.svg";
export { ForwardRef as ReactComponent };